module.exports = __webpack_public_path__ + "static/media/nuu_dee_Produce_Ing_Logo_MgmtCslt.19402eb3.jpg";